<div class="white-box main-black mt-4 p-4 border-radius">
	<div>
		<h4>{{ title | translate }}</h4>
	</div>

	<div class="d-flex flex-wrap justify-content-between py-4">
		<div class="d-flex justify-content-start col-12 align-items-center px-0">
			<!-- select year -->
			<div class="col-4 pl-0">
				<label class="mr-2">{{'g.select_year' | translate}}</label>
				<ng-select
					[searchable]="false"
					[items]="yearList"
					bindLabel="label"
					bindValue="id"
					placeholder="{{'g.select_year' | translate}}"
					name="year"
					[(ngModel)]="selectedYear"
					[clearable]="false"
					(change)="getIotemeterEnergyConsumption()"
				></ng-select>
			</div>

			<!-- select period type -->
			<div class="col-4" *ngIf="selectedYear != allYearsId">
				<label class="mr-2">{{'site.select_period_type' | translate}}</label>
				<ng-select
					[items]="periodTypes"
					bindLabel="label"
					bindValue="value"
					placeholder="{{'site.select_period_type' | translate}}"
					name="period_type"
					[(ngModel)]="selectedPeriodType"
					[clearable]="false"
					(change)="getIotemeterEnergyConsumption()"
				></ng-select>
			</div>

			<!-- select Device Type -->
			<div class="col-4" *ngIf="!device">
				<label class="mr-2">{{'iotemeter_site_energy_report.select_meter_type' | translate}}</label>
				<ng-select
					[searchable]="false"
					[items]="devicesList"
					bindLabel="label"
					bindValue="value"
					placeholder="{{'iotemeter_site_energy_report.select_meter_type' | translate}}"
					name="device_type"
					[(ngModel)]="selectedDeviceType"
					[clearable]="false"
					(ngModelChange)="getIotemeterEnergyConsumption()"
				></ng-select>
			</div>
		</div>
	</div>

	<!-- table -->
	<div class="w-100">
		<sct-custom-table
			[columnsConfig]="columnConfig"
			[data]="data"
			[config]="tableConfig"
		></sct-custom-table>
	</div>

</div>